import { Route, Routes } from "react-router-dom";
import Consultation from "../pages/Consultation";
import Course from "../pages/Course";
import Lecture from "../pages/Lecture";
import InstructorProfile from "../pages/InstructorProfile";
import Layout from "../components/Layout/Layout";
import Courses from "../pages/Courses";
import UserProfile from "../pages/StudentProfile";
import Certificate from "../pages/Certificate";
import Error from "../pages/Error";
import QuizAnswers from "../pages/QuizAnswers";
import EssayQuizAnswers from "../pages/EssayQuizAnswers";
import Blog from "../pages/Blog";
import CartCheckout from "../pages/CartCheckout";
import SupportCenter from "../pages/SupportCenter";
import TermsAndConditions from "../pages/TermsAndConditions";
import ComplaintsPolicyPage from "../pages/ComplaintsPolicy";
import Book from "../pages/Books";
import AllBooks from "../pages/AllBooks";
import Home2 from "../pages/Home2";
import AboutUs2 from "../pages/AboutUs2";
import ContactUs from "../pages/ContactUs";
import FAQs from "../pages/FAQs";
import Blogs from "../pages/Blogs";
import AccountSettings from "../pages/AccountSettings";
import Training from "../pages/Training";
import OfflineCourse from "../pages/OfflineCourse";
import IFRSExamLayout from "../pages/IfExam/Layout/IFRS-Exam-Layout";
import { Svgifier } from "@sumcode/svgify";
import "@sumcode/svgify/styles";
import ExamPage from "../pages/IfExam/Pages/ExamPage/ExamPage";
import ResultsPage from "../pages/IfExam/Pages/ResultsPage/ResultsPage";
import Test from "./Test";
import IFRSInstructionsSkip from "../pages/IfExam/Pages/InstructionsPage/InstructionsSkip";
import Roadmap from "../pages/Roadmap";

// import ExamGenerator from "../pages/ExamGenerator";
const MainRoutes = () => {
  return (
    <Svgifier version={10} clearForOldVersion>
      <Routes>
        <Route path="ifrs-exam/:exam_id" element={<IFRSExamLayout />}>
          <Route index element={<IFRSInstructionsSkip />} />
          <Route path="exam/:question_id" element={<ExamPage />} />
          <Route path="results" element={<ResultsPage />} />
        </Route>

        <Route element={<Layout />}>
          <Route index element={<Home2 />} />
          <Route path="/about-us" element={<AboutUs2 />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/support-center" element={<SupportCenter />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/complaints-policy" element={<ComplaintsPolicyPage />} />
          {/* <Route path="/exam-generator" element={<ExamGenerator />} /> */}
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/books" element={<AllBooks />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/my-profile" element={<UserProfile />} />
         <Route path="/roadmap" element={<Roadmap />} /> 
          <Route path="/certificate" element={<Certificate />} />
          <Route
            path="/quiz-answers/:quizId/:num_trial"
            element={<QuizAnswers />}
          />
          <Route
            path="/essay-quiz-answers/:quizId/:num_trial"
            element={<EssayQuizAnswers />}
          />
          <Route path="/course/:id" element={<Course />} />
          <Route path="/offline-course/:id" element={<OfflineCourse />} />
          <Route path="/book/:id" element={<Book />} />
          <Route path="/lecture/:id/:id" element={<Lecture />} />
          <Route path="/cart-checkout" element={<CartCheckout />} />
          <Route path="/blog/:id" element={<Blog />} />
          <Route path="/instructor/:id" element={<InstructorProfile />} />
          <Route path="/settings" element={<AccountSettings />} />
          <Route path="/*" element={<Error />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/training" element={<Training />} />
        </Route>

        <Route path="/spreadsheet-view" element={<Test />} />
      </Routes>
    </Svgifier>
  );
};

export default MainRoutes;
